import React, { useState, useEffect } from 'react';
import CIDSearchInput from './components/CIDSearchInput';
import CIDList from './components/CIDList';
import { getCIDs } from './services/CIDFirebaseService';
import { useDebounce } from './hooks/CIDUseDebounce';
import Layout from '../../components/layout/Layout';
import LoadingSpinner from '../../components/LoadingSpinner';
import Toast, { showToast } from '../../components/Toast';
import CIDPagination from '../../components/CIDPagination';

const CIDSearchPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterType, setFilterType] = useState('name');
  const [cids, setCIDs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0); // Garantir que totalResults está correto
  const [pageSize, setPageSize] = useState(20);

  const debouncedSearchTerm = useDebounce(searchQuery, 500);

  // Atualizando o total de CIDs ao carregar a página ou mudar a busca
  useEffect(() => {
    if (debouncedSearchTerm) {
      fetchCIDs(debouncedSearchTerm, filterType, currentPage);
    } else {
      fetchInitialCIDs(); // Exibe os itens iniciais sem busca
    }
  }, [debouncedSearchTerm, currentPage, pageSize]);

  const fetchInitialCIDs = async () => {
    try {
      setLoading(true);
      setError('');
      const result = await getCIDs('', 'name', pageSize, currentPage);
      setCIDs(result.items);
      setTotalResults(result.total); // Total de resultados
      setLoading(false);
    } catch {
      setLoading(false);
      setError('Erro ao carregar dados.');
      showToast('Erro ao carregar os dados iniciais.', 'error');
    }
  };

  const fetchCIDs = async (query, filterType, page) => {
    try {
      setLoading(true);
      setError('');
      const result = await getCIDs(query, filterType, pageSize, page);
      setCIDs(result.items);
      setTotalResults(result.total); // Total de resultados baseado na busca
      setLoading(false);
    } catch {
      setLoading(false);
      setError('Erro ao buscar dados.');
      showToast('Erro ao buscar CID.', 'error');
    }
  };

  const handleSearch = (search) => {
    setSearchQuery(search.query);
    setFilterType(search.type);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1); // Volta à primeira página ao mudar o número de itens por página
  };

  return (
    <Layout>
      <Toast />
      <h1 className="font-bold text-center mb-6">Consulta CID</h1>
      <div className="mb-6">
        <CIDSearchInput onSearch={handleSearch} />
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <p className="text-red-500 text-center">{error}</p>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
            <CIDList cids={cids} />
          </div>
          <div className="mt-6">
            <CIDPagination
              currentPage={currentPage}
              totalResults={totalResults}
              pageSize={pageSize}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
            />
          </div>
        </>
      )}
    </Layout>
  );
};

export default CIDSearchPage;
